import { useTranslation } from 'react-i18next';

// Absolute HH:MM:SS clock time, always 24h regardless of locale -- used for
// live event feed cards (see EventCard) where an absolute timestamp is
// clearer than a relative "time ago" (detections, decision-tree run events).
export default function useClockTime(date: number) {
  const { i18n } = useTranslation();
  return new Intl.DateTimeFormat(i18n.language, {
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  }).format(date);
}
